import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  imageHeight: number
  imageWidth: number
  containerHeight: number
}>()((theme, { containerHeight, imageHeight, imageWidth }) => {
  return {
    rootContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: theme.spacing(containerHeight),
      marginTop: theme.spacing(2.5),
    },
    emptyStateImg: {
      pointerEvents: 'none',
      height: theme.spacing(imageHeight),
      width: theme.spacing(imageWidth),
    },
    description: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'center',
      marginTop: theme.spacing(2),
    },
  }
})
